import { blue50, blue60 } from '../../../colors/blue';
import { gray20, gray40, white, whiteopacity80 } from '../../../colors/gray';
import { rem } from '../../../utils/rem';
export var checkbox = {
    '--ag-checkbox-background-color': whiteopacity80,
    '& .ag-checkbox-input-wrapper': {
        borderRadius: 1,
        '&:focus-within': { boxShadow: 'none' },
        '&:after': {
            alignItems: 'center',
            border: "".concat(rem(1), " solid ").concat(gray40),
            borderRadius: 1,
            display: 'flex',
            fontFamily: 'ydsIcon',
            fontSize: rem(10),
            height: rem(16),
            justifyContent: 'center',
            width: rem(16),
            // Fix mozilla display of not known icon.
            content: "''",
        },
        '&:hover:after': {
            color: gray20,
            content: '"\\e800"',
        },
        '&.ag-checked': {
            '--ag-checkbox-background-color': blue50,
            '&:after': {
                border: 'none',
                color: white,
                content: '"\\e800"',
            },
            '&:hover': {
                '--ag-checkbox-background-color': blue60,
            },
        },
        '&.ag-indeterminate': {
            '&:after': {
                color: blue50,
                content: '"\\e80a"',
                fontSize: rem(12),
            },
            '&:hover:after': {
                color: blue60,
            },
        },
    },
    '& .ag-checkbox-input': {
        cursor: 'pointer',
    },
};
